// extracted by mini-css-extract-plugin
export default {"custom-header":"CustomHeaderConfirm_custom-header__DqPpH","icon":"CustomHeaderConfirm_icon__ij6l6"};